<template>
  <div class="content extended-forms">
    <div class="row">
      <div class="col-md-3">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getContents" class="select-primary" size="large" placeholder="선택" v-model="state.state">
              <el-option v-for="option in state.options" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
      <div class="col-md-3">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-select @change="getContents" class="select-primary" size="large" placeholder="선택" v-model="sort">
              <el-option v-for="option in sortOptions" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
            </el-select>
          </div>
        </div>
      </div>
    </div>

    <div class="row">
      <div class="col-md-4">
        <h4 class="card-title text-left">기간</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <el-date-picker type="daterange" start-placeholder="검색 시작일" end-placeholder="검색 종료일" v-model="searchPeriod" />
          </div>
        </div>
      </div>

      <div class="col-md-2">
        <h4 class="card-title text-left">검색어</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-input placeholder="검색어" v-model="searchWord">
              <span slot="helpBlock" class="form-text" />
            </base-input>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <h4 class="card-title text-left">&nbsp;</h4>
        <div class="row">
          <div class="col-md-12 text-left">
            <base-button @click="getContents('detail')" type="default">검색</base-button>
          </div>
        </div>
      </div>
      <div class="col-md-2 text-left">
        <h4 class="card-title text-left">노출 개수</h4>
        <el-select @change="getContents" class="select-primary" size="large" placeholder="선택" v-model="limit">
          <el-option v-for="option in pageCounts" class="select-primary" :value="option.value" :label="option.label" :key="option.label" />
        </el-select>
      </div>
    </div>
    <div class="col-md-12">
      <h4 class="card-title text-left" />
      <div class="row">
        <div class="col-md-4 text-left">
          <base-button @click="hideContents()" type="danger">선택숨김</base-button>
        </div>
        <div class="col-md-4">
          <base-radio name="basic" inline v-model="viewType">기본</base-radio>
          <base-radio name="list" inline v-model="viewType">리스트</base-radio>
        </div>
      </div>
    </div>
    <div class="row" v-if="viewType === 'basic'">
      <div class="col-sm-3" v-for="(item, index) in list" v-bind:key="item.id">
        <CardLayout
          :key="index"
          :index="index"
          :contentId="item.id"
          :fileIds="item.fileIds"
          :title="item.text"
          :state="item.state"
          :regDate="item.regTime"
          :btnDelete="true"
          :btnDetail="true"
          :has-check="true"
          @setCheckBox="setCheckBox"
          @contentDetail="goContentDetail"
          @deleteContent="deleteContent"
        />
      </div>
    </div>
    <div class="row" v-if="viewType === 'list'">
      <div class="col-md-12">
        <el-table :data="list">
          <el-table-column v-for="column in tableColumns" :key="column.label" :min-width="column.minWidth" :prop="column.prop" :label="column.label" />
          <el-table-column :min-width="135" align="right" label="웹페이지">
            <div slot-scope="props">
              <base-button @click.native="goHomepageUrl(props.row.id)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
          <el-table-column :min-width="135" align="right" label="상세">
            <div slot-scope="props">
              <base-button @click.native="goContentDetail(props.row)" class="edit btn-link" type="warning" size="sm" icon>
                <i class="tim-icons icon-pencil" />
              </base-button>
            </div>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="row">
      <base-pagination class="pagination-no-border" v-model="currentPage" :pageCount="totalPages" />
    </div>
  </div>
</template>
<script>
import CardLayout from "@/pages/Components/CardLayout.vue";
import { BaseButton, BaseInput, BasePagination } from "@/components/index";
import swal from "sweetalert2";
import moment from "moment";
import Endpoints from "@/common/Endpoints";
import _ from "lodash";

export default {
  components: {
    CardLayout,
    BaseInput,
    BaseButton,
    BasePagination,
  },
  async created() {
    if (!_.isEmpty(this.$route.query)) {
      if (this.$route.query.state) {
        this.state.state = parseInt(this.$route.query.state);
      } else {
        this.state.state = null;
      }
      if (this.$route.query.searchWord) {
        this.searchWord = this.$route.query.searchWord;
      }
      if (this.$route.query.startDate && this.$route.query.endDate) {
        this.searchPeriod = [moment(this.$route.query.startDate, "YYYY-MM-DD").toDate(), moment(this.$route.query.endDate, "YYYY-MM-DD").toDate()];
      }
    }
    await this.getContents();
  },
  data() {
    return {
      searchWord: null,
      viewType: "basic",
      limit: 20,
      pageCounts: [
        { label: 20, value: 20 },
        { label: 50, value: 50 },
        { label: 100, value: 100 },
      ],
      state: {
        state: 1,
        options: [
          { label: "전체", value: null },
          { label: "노출", value: 1 },
          { label: "숨김", value: 0 },
          { label: "삭제", value: -1 },
        ],
      },
      searchPeriod: [],
      list: [],
      tableColumns: [
        {
          prop: "id",
          label: "ID",
          minWidth: 50,
        },
        {
          prop: "text",
          label: "내용",
          minWidth: 150,
        },
        {
          prop: "regTime",
          label: "작성일",
          minWidth: 150,
        },
        {
          prop: "nickname",
          label: "작성자",
          minWidth: 120,
        },
      ],
      currentPage: 1,
      totalPages: 1,
      unitId: null,
      sortOptions: [
        { label: "최근순", value: "DESC" },
        { label: "시간순", value: "ASC" },
      ],
      sort: "DESC",
    };
  },
  watch: {
    currentPage: {
      handler() {
        this.getContents(this.$route.query.withParams, this.currentPage);
      },
    },
  },
  methods: {
    async getContents(withParams, page) {
      const queryParams = {
        state: this.state.state ?? undefined,
        sort: this.sort,
      };
      const params = { state: this.state.state, sort: this.sort, limit: this.limit };
      params.currentPage = page ? page : 1;
      if (withParams === "detail" || this.$route.query.withParams === "detail") {
        if (!this.searchPeriod) {
          window.Toast.error("검색기간을 입력해 주세요");
          return;
        }
        if (this.searchPeriod) {
          queryParams.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString(true) : undefined;
          queryParams.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString(true) : undefined;
          params.startDate = this.searchPeriod?.[0] ? moment(this.searchPeriod[0]).hour(0).minute(0).second(0).toISOString() : undefined;
          params.endDate = this.searchPeriod?.[1] ? moment(this.searchPeriod[1]).hour(23).minute(59).second(59).toISOString() : undefined;
        }

        queryParams.searchWord = this.searchWord;
        queryParams.withParams = "detail";
        params.searchWord = this.searchWord;
        params.startTime = this.searchPeriod[0];
        params.endTime = this.searchPeriod[1];
      }
      const url = `/homepage/community`;
      return this.$axios
        .get(url, {
          params,
        })
        .then((res) => {
          this.list = res.data.data.data;
          this.totalPages = Number(res.data.data.page);
          for (let i = 0; i < this.list.length; i++) {
            if (this.list[i].imageIds) {
              this.list[i].fileIds = this.list[i].imageIds.split(",");
            }
            this.list[i].isChecked = false;
            this.list[i].state = this.list[i].deleteAt ? -1 : this.list[i].visibility;
          }
        });
    },

    async deleteContent(param) {
      const contentId = param.contentId;
      swal
        .fire({
          title: "숨김 확인",
          text: `${contentId}번 게시글을 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            try {
              return this.$axios
                .put(`/homepage/community/${contentId}/state`, {
                  params: { unitId: this.unitId, state: 0 },
                })
                .then(() => {
                  window.Toast.success("게시글이 숨김 되었습니다");
                  this.getContents();
                });
            } catch (err) {
              window.Toast.error("게시글 숨김 중 에러가 발생하였습니다.");
            }
          }
        });
    },
    async hideContents() {
      swal
        .fire({
          title: "숨김 확인",
          text: `선택된 게시글을 숨김하시겠습니까?`,
          type: "warning",
          showCancelButton: true,
          customClass: {
            confirmButton: "btn btn-danger btn-fill",
            cancelButton: "btn btn-cancel btn-fill",
          },
          confirmButtonText: "숨김",
          cancelButtonText: "취소",
          buttonsStyling: false,
        })
        .then(async (selection) => {
          if (selection.value) {
            const contentIds = this.list
              .filter((item) => item.isChecked)
              .map((item) => {
                return item.id;
              });
            if (contentIds.length === 0) {
              window.Toast.error("선택된 게시글이 없습니다");
              return;
            }
            for (const contentId of contentIds) {
              await this.$axios.put(`/homepage/community/${contentId}/state`, { params: { state: 0 } });
            }
            this.list.forEach((item, index) => {
              // item.isChecked = false;
              if (contentIds.includes(item.id)) {
                this.list.splice(index, 1);
              }
            });
            window.Toast.success("게시글이 숨김 되었습니다");
          }
        });
    },

    goContentDetail(param) {
      window.open(`/homepage/community/detail?id=${param.id || param.contentId}`);
    },

    setCheckBox(param) {
      this.list[param.index].isChecked = param.isChecked;
    },

    goHomepageUrl(id) {
      window.open(`${Endpoints.homepageUrl}/community/${id}`);
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  .row {
    margin-bottom: 20px;
  }
}
</style>
